import * as React from "react";
import { IconProps } from "../types";

const CropIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="18"
        height="18"
        fill="none"
        viewBox="0 0 18 18"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M13.25 17C12.836 17 12.5 16.664 12.5 16.25V5.75C12.5 5.612 12.388 5.5 12.25 5.5H7.25C6.836 5.5 6.5 5.164 6.5 4.75C6.5 4.336 6.836 4 7.25 4H12.25C13.215 4 14 4.785 14 5.75V16.25C14 16.664 13.664 17 13.25 17Z"
          fill={color}
        />
        <path
          d="M4.75 5.5H1.75C1.336 5.5 1 5.164 1 4.75C1 4.336 1.336 4 1.75 4H4.75C5.164 4 5.5 4.336 5.5 4.75C5.5 5.164 5.164 5.5 4.75 5.5Z"
          fill={color}
        />
        <path
          d="M16.25 14H5.75C4.785 14 4 13.215 4 12.25V1.75C4 1.336 4.336 1 4.75 1C5.164 1 5.5 1.336 5.5 1.75V12.25C5.5 12.388 5.612 12.5 5.75 12.5H16.25C16.664 12.5 17 12.836 17 13.25C17 13.664 16.664 14 16.25 14Z"
          fill={color}
        />
      </svg>
    );
  },
);

export default CropIcon;
